import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const Gallery = ({ id, titleName, facID }) => {
  const [images, setImages] = useState([]);

  const fetchImages = async () => {
    try {
      const response = await corefetch(
        `Gallery/GetImageDetails?eventTypeId=${id}`
      );
      setImages(response);
    } catch (error) {
      console.error("Error fetching images:", error);
      setImages([]);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  useEffect(() => {
    if (images && images.length) {
      setTimeout(function () {
        if ($(".fancybox").length) {
          $(".fancybox").fancybox({
            openEffect: "elastic",
            closeEffect: "elastic",
            wrapCSS: "project-fancybox-title-style",
          });
        }
      }, 300);
    }
  }, [JSON.stringify(images)]);

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <section
      className="wpo-portfolio-section-s2 pb-0 section-padding gallery"
      id="gallery"
    >
      <div className="container">
        <div className="wpo-section-title">
          <h4>Photo Gallery</h4>
          <h2>FEATURED REAL {titleName}</h2>
        </div>
        <div className="sortable-gallery">
          <div className="gallery-filters" />
          <div
            className="row"
            style={{
              rowGap: "30px",
              justifyContent: "center",
            }}
          >
            {images.map((image, index) => (
              <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                <div
                  className="card"
                  style={{
                    overflow: "hidden",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    position: "relative",
                  }}
                >
                  <div
                    className="img-holder"
                    style={{
                      position: "relative",
                    }}
                  >
                    <a
                      href={`${ImageURL}${image.imagePath}`}
                      className="fancybox"
                      data-fancybox-group="gall-1"
                      style={{
                        display: "block",
                        position: "relative",
                      }}
                    >
                      <img
                        src={`${ImageURL}${image.imagePath}`}
                        alt=""
                        className="img img-responsive"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          transition: "transform 0.3s ease",
                        }}
                      />
                      {/* <div
                        className="hover-overlay"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(255, 255, 255, 0)",
                          opacity: 0,
                          transition:
                            "opacity 0.3s ease, background-color 0.3s ease",
                        }}
                      ></div> */}
                      {/* Plus Icon */}
                      <div className="hover-content">
                        <i className="ti-plus"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <a
            href={`/gallery/${facID}/BallRoom`}
            className="theme-btn read-more-btn"
          >
            View More
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
